<nz-layout class="app-layout">

    <nz-header style="padding: 0; background: #fff; position: relative; z-index: 1000; box-shadow: 0 2px 8px rgba(0,0,0,0.15);">
        <app-topbar></app-topbar>
    </nz-header>

    <nz-layout class="inner-layout" nzHasSider>

        <nz-sider 
            class="menu-sidebar" 
            nzCollapsible 
            nzBreakpoint="md" 
            [nzCollapsedWidth]="80"
            [(nzCollapsed)]="isCollapsed" 
            [nzTrigger]="null"
            [nzWidth]="200">

            <div class="sidebar-logo">
                <button class="toggle-btn" (click)="isCollapsed = !isCollapsed">
                    <span nz-icon [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"></span>
                </button>
            </div>

            <ul nz-menu nzTheme="dark" nzMode="inline" [nzInlineCollapsed]="isCollapsed">
                
                <li nz-menu-item nzMatchRouter>
                    <span nz-icon nzType="dashboard"></span>
                    <span>Dashboard</span>
                    <a routerLink="/dashboard"></a>
                </li>

                @if (authService.hasAccess(PermissionEnum.UsersView)) {
                    <li nz-menu-item nzMatchRouter>
                        <span nz-icon nzType="user"></span>
                        <span>Users</span>
                        <a routerLink="/user/view-user"></a>
                    </li>
                }

                @if (authService.hasAccess(PermissionEnum.ProductsView)) {
                    <li nz-menu-item nzMatchRouter>
                        <span nz-icon nzType="product"></span>
                        <span>Products</span>
                        <a routerLink="/product/view-product"></a>
                    </li>
                }

                @if (authService.hasAccess(PermissionEnum.SdksView)) {
                    <li nz-menu-item nzMatchRouter>
                        <span nz-icon nzType="tool"></span>
                        <span>SDKs</span>
                        <a routerLink="/sdk/view-sdk"></a>
                    </li>
                }

                @if (authService.hasAccess(PermissionEnum.EmailView) || authService.hasAccess(PermissionEnum.EmailCompose)) {
                    <li nz-submenu nzTitle="Email" nzIcon="mail">
                        <ul>
                            @if (authService.hasAccess(PermissionEnum.EmailCompose)) {
                                <li nz-menu-item nzMatchRouter>
                                    <span>Compose Email</span>
                                    <a routerLink="/email"></a>
                                </li>
                            }
                            @if (authService.hasAccess(PermissionEnum.EmailView)) {
                                <li nz-menu-item nzMatchRouter>
                                    <span>View Emails</span>
                                    <a routerLink="/email/view"></a>
                                </li>
                            }
                        </ul>
                    </li>
                }

                @if (authService.hasAccess(PermissionEnum.FilesBrowse)) {
                    <li nz-menu-item nzMatchRouter>
                        <span nz-icon nzType="file"></span>
                        <span>Files</span>
                        <a routerLink="/files/view-files"></a>
                    </li>
                }

            </ul>
        </nz-sider>

        <nz-content>
            <div class="inner-content-wrapper">
                <router-outlet></router-outlet>
            </div>
        </nz-content>

    </nz-layout>
</nz-layout>

<app-change-password-modal modalId="changePasswordModal"></app-change-password-modal>